import Menus from "../Menus";

const HelpTopicSignalProbleme = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Signaler un problème', link: '/topics/securite/signal-probleme'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicSignalProbleme'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicSignalProbleme